var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "editable-cell"
  }, [_vm.editable ? _c("div", {
    staticClass: "editable-cell-input-wrapper"
  }, [_c("a-input", {
    attrs: {
      maxLength: 100
    },
    on: {
      pressEnter: _vm.check
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }), _c("a-icon", {
    staticClass: "editable-cell-icon-check",
    attrs: {
      type: "check"
    },
    on: {
      click: _vm.check
    }
  })], 1) : _c("div", {
    staticClass: "editable-cell-text-wrapper"
  }, [_vm.value ? _c("div", {
    staticStyle: {
      "min-width": "1px"
    }
  }, [_c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.value) + " ")]), _c("div", {
    staticClass: "line-1"
  }, [_vm._v(_vm._s(_vm.value))])], 2)], 1) : _c("div", [_vm._v(" -- ")]), _c("a-icon", {
    staticClass: "editable-cell-icon",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.edit
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };